












































































































































































































































































































































































import { Component, Mixins, Ref } from "vue-property-decorator";

import Modal from "@/components/custom/modal/Modal.vue";
import { useDate } from "@/hooks";
import useInvoiceRecurringDashboard, {
  FilterField,
} from "@/hooks/useInvoiceRecurringDashboard";
import MNotification from "@/mixins/MNotification.vue";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { InvoiceRecurringDashboardDetailResponseDto } from "@/models/interface/invoice-recurring-dashboard/InvoiceRecurringDashboardDetailResponseDto.interface";
import { InvoiceRecurringDashboardParams } from "@/models/interface/invoice-recurring-dashboard/InvoiceRecurringDashboardParams.interface";
import {
  InvoiceRecurringDashboardContract,
  InvoiceRecurringDashboardResponseDto,
} from "@/models/interface/invoice-recurring-dashboard/InvoiceRecurringDashboardResponseDto.interface";
import { FormUtils } from "@/utils/FormUtils";
import { FormModel } from "ant-design-vue";
import SelectCustomer from "../custom/select/SelectCustomer.vue";

@Component({
  components: {
    Modal,
    SelectCustomer,
  },
})
export default class InvoiceRecurringReport extends Mixins(MNotification) {
  collapsedCustomers: string[] = [];
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  selected: InvoiceRecurringDashboardDetailResponseDto | null = null;
  loading = {
    find: false,
    detail: false,
  };
  dashboard: InvoiceRecurringDashboardResponseDto | null = null;
  show = {
    detail: false,
  };
  @Ref("formModel")
  formModel!: FormModel;

  form: FilterField = {
    customer: undefined,
    date: [],
  };

  get kpis(): any[] {
    return [
      {
        label: this.$t("lbl_total_invoice_amount_dpp"),
        value: this.dashboard ? this.dashboard.totalInvoiceAmount : "-",
        color: "blue",
      },
      {
        label: this.$t("lbl_total_outstanding_dpp"),
        value: this.dashboard ? this.dashboard.totalOutstanding : "-",
        color: "orange",
      },
      {
        label: this.$t("lbl_not_invoiced_dpp"),
        value: this.dashboard ? this.dashboard.totalNotInvoiced : "-",
        color: "red",
      },
    ];
  }

  get isAllCollapsed(): boolean {
    if (!this.dashboard) return false;
    return this.dashboard.customers.every(c =>
      this.collapsedCustomers.includes(c.customerId)
    );
  }

  get validationSchema() {
    return {
      date: [FormUtils.mandatory(), FormUtils.maxOneYear()],
    };
  }

  handleReset(): void {
    this.formModel.resetFields();
  }

  toggleAll(): void {
    if (!this.dashboard) return;
    if (this.isAllCollapsed) {
      this.collapsedCustomers = [];
    } else {
      this.collapsedCustomers = this.dashboard.customers.map(c => c.customerId);
    }
  }

  toggleCustomer(customerId: string): void {
    if (this.collapsedCustomers.includes(customerId)) {
      this.collapsedCustomers = this.collapsedCustomers.filter(
        id => id !== customerId
      );
      return;
    }

    this.collapsedCustomers.push(customerId);
  }

  isCollapsed(customerId: string): boolean {
    return this.collapsedCustomers.includes(customerId);
  }

  openDetail(contract: InvoiceRecurringDashboardContract): void {
    this.getDashboardDetail(contract);
  }

  getStatusColor(status: string): string {
    if (status === "APPROVED") return "green";
    if (status === "CLOSED") return "default";
    return "orange";
  }
  onSubmit(): void {
    this.formModel.validate(valid => {
      if (!valid) return;

      this.loading.find = true;

      this.getDashboard();
    });
  }

  handleCloseModal(): void {
    this.show.detail = false;
    this.selected = null;
  }

  constructParams(): InvoiceRecurringDashboardParams {
    const { toStartDay, toEndDay } = useDate();

    return {
      customerId: this.form.customer ? this.form.customer.key : undefined,
      dateFrom: this.form.date ? toStartDay(this.form.date[0]).format() : "",
      dateTo: this.form.date ? toEndDay(this.form.date[1]).format() : "",
      byUser: true,
    };
  }

  getDashboard(): void {
    this.loading.find = true;

    const { findAll } = useInvoiceRecurringDashboard();

    findAll(this.constructParams())
      .then(response => {
        this.dashboard = response;
        this.collapsedCustomers = response.customers.map(c => c.customerId);
      })
      .finally(() => {
        this.loading.find = false;
      });
  }

  getDashboardDetail(contract: InvoiceRecurringDashboardContract): void {
    const { findByIcId } = useInvoiceRecurringDashboard();

    findByIcId(contract.icId, this.constructParams())
      .then(response => {
        this.selected = response;
        this.show.detail = true;
      })
      .finally(() => {
        this.loading.find = false;
      });
  }
}
